export const IMAGE_SPECS = {
	'sliders-desktop': 'Tamaño: 1600px x 380px - Peso máximo 150kb',
	'sliders-mobile': 'Tamaño: 540px x 270px - Peso máximo 75kb',
	popup: 'Tamaño: 600px x 300px - Peso máximo 150kb',
	sidebar: 'Tamaño: 540px x máx. 4000px - Peso máximo 120kb',
	'horizontal-box': 'Tamaño: 911px x 511px - Peso máximo: 150 kb',
	'vertical-box':'Tamaño: 500px x 679px - Peso máximo: 150 kb',
};
